
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 2h5a1 1 0 000-2h-5a1 1 0 000 2zM5.62 12.18v17.88a2 2 0 002 2h16.76a2 2 0 002-2V12.18a1 1 0 00-1-1 1 1 0 00-1 1v16.88a1 1 0 01-1 1H8.62a1 1 0 01-1-1V12.18a1 1 0 00-1-1 1 1 0 00-1 1z"}}),_c('path',{attrs:{"d":"M13.81 25V14a1 1 0 00-2 0v11a1 1 0 002 0zM20.19 25V14a1 1 0 00-2 0v11a1 1 0 002 0zM16 7A25.55 25.55 0 004.1 9.76a1 1 0 01-1.39-.85.93.93 0 01.44-.8A23.91 23.91 0 0116 4.75a23.91 23.91 0 0112.85 3.36.93.93 0 01.44.8 1 1 0 01-1.39.85A25.55 25.55 0 0016 7z"}})])
          )
        }
      }
    